export default __webpack_public_path__ + "static/teams-pattern-499b2278a93884e33ebae4726eb3f5c2.svg";